@if (isCopyrightTitleTask) {
<app-copyright-title-task-details
  [taskId]="taskId"
></app-copyright-title-task-details>
} @else {
<app-task-details
  [productionOrderIdentifier]="productionOrderIdentifier"
  [taskType]="taskType"
></app-task-details>
}
